module.exports = __webpack_public_path__ + "34d10f41f6191e972207621b386e5444.svg";